module.exports = __webpack_public_path__ + "6249d2162db6b867b91b18d131f975b6.png";